<template>
  <div class="setting-content">
    <h2 class="content-title">修改管理员密码</h2>
    <div class="box">
      <div class="input">
        <el-input v-model="password" placeholder="输入密码" type="password"></el-input>
      </div>
      <div class="input">
        <el-input v-model="repassword" placeholder="请再次输入密码" type="password"></el-input>
      </div>
      <el-button @click="resetPassword()">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "user",
  data() {
    return {
      password: null,
      repassword: null,
    }
  },
  methods:{
    resetPassword(){
      if (this.password !== this.repassword){
        this.$message.error("两次输入的密码不一样！")
        return
      }
      if (this.password == '' || this.password == null){
        this.$message.warning("请输入密码！")
        return
      }

      this.axios.post("/user/resetPassword", {password: this.password}).then((response) => {
        this.$message.success("修改成功")
      }).catch((error) => {
        this.$message.error(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .setting-content{
    height: 780px;
    margin: 50px;
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    align-items: center;
    padding-top: 150px;
    background: rgba(255,255,255,0.3900);
    box-shadow: 0px 0px 24px rgba(8,36,94,0.1600);
    border-radius: 8px;

    .content-title{
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 82px;
      color: #333333;
    }
    .box{
      display: flex;
      margin-top: 100px;
      /*display: -webkit-flex;*/
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .input {
      margin-bottom: 50px;
      width: 400px;
    }
    .el-button{
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      width: 400px;
      height: 45px;
      background: #08245E;
      border-radius: 8px;
    }
  }


</style>